import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs';

import { ProductSubVariationsDto, ProductDto } from '../../../../../../../../../src/shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/app-component-base';
import { ShoppingCardService } from '../services/shopping-card.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';

@Component({
  selector: 'kt-special-code-modal',
  templateUrl: './special-code-modal.component.html',
  styleUrls: ['./special-code-modal.component.scss']
})
export class SpecialCodeModalComponent extends AppComponentBase implements OnInit {

	selectVariationProduct;
	orderedQty: number = 0;
	subVariationList = new BehaviorSubject<ProductSubVariationsDto[]>([]);


	isCheckVariationProduct = new BehaviorSubject<boolean>(false);

	//desc = "Ürünün lotuna ait varyasyon stoklarını görebilir ve talepde bulunabilirsiniz.";
	desc = this.localization.localize("FE.ORDER.FORMS.INFOALERTS.COMMON.VARIATIONLOTORDERED", this.localizationSourceName);

	constructor(
		injector: Injector,
		private shoppingCardService: ShoppingCardService,
		private customLocalization: CustomLocalizationService,
		public dialogRef: MatDialogRef<SpecialCodeModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public _data: any
	) {

		super(injector);

	}

	ngOnInit() {


		this.getSubVariations();
	}

	private getSubVariations() {

		console.log("özel kodlu talep için özel bir modal: " + this._data);


		//Sepet içerisinde tüm kayıtlı datalrı getir diyoruz.
		var registeredProductData = this.shoppingCardService.getItems().getValue();

		//Arka taraftan dönen varyasyonlu ürünün içerisinde geziyoruz
		//sepet içerisin de o ürün ve varyasyon da bir kayıt varsa qty sini ürün listesinde ki ilgli varyasyon içerisine setliyoruz.
		this._data.productItem.subVariations.forEach(product => {
			console.log(product);
			let registerData = registeredProductData.find(x => x.id == this._data.productId && x.variationId == product.variationId);
			if (registerData) {

				this.selectVariationProduct = product;
				this.orderedQty = registerData.orderedQty;

			}

		});

		if (this._data.productItem.subVariations.length < 1) {
			return this.isCheckVariationProduct.next(true);
		}

		this.subVariationList.next(this._data.productItem.subVariations);

	}


	onChangeSpecialVariationProduct() {

		this.orderedQty = 0;

	}

	//bir talep girilip o textbox dan çıkıldığı anda girilen talep adedini alır ve sorgular
	//eğer stok adedinden ya da total talep adedinden büyük ise hata dönderir ve değeri sıfırlarız.
	onBlurStokControlByOrderedQty() {

		console.log("stok görme yetkisi kontrolu:" + this._data.stokView);
		//stok görme yetkisi yok ise stok kontrolu yaptırmıyoruz.
		if (!this._data.stokView) {
			return;

		}

		var selectStok = this.selectVariationProduct.stockQuantity;
		var selectOrderedQty = this.orderedQty;
		//girdiği stok adedi stok tan büyükse talep adedini sıfırla diyoruz
		//ana grid deki tıklanan ürünün stok adedi modal içerisinde varyasyonlu
		//ürünlerin içerisine girilen talep adetlerinin toplamında küçük ise gir diyoruz.
		if (selectStok < selectOrderedQty) {

			this.orderedQty = 0;
			return this.uiMessage.modal.warning(this.customLocalization.l("FE.ALERTMESSAGES.STOCK.HEADER"), this.customLocalization.l("FE.ALERTMESSAGES.STOCK.OVERSTOCK"), null);
		}

	}

	btnProductSave() {

		//if (this.orderedQty < 1) {
		//	return this.uiMessage.modal.warning("", "En az bir tane stok adedi girmeden kaydet yapamazsınız.", null);
		//}
		//else if (!this.selectVariationProduct) {
		//	return this.uiMessage.modal.warning("", "Bir varyasyon seçmeden kaydet yapamazsınız.", null);

		//}

		if (!this.selectVariationProduct) {
			return this.uiMessage.modal.warning("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.EXPIRATIONDATELOTMODAL.VARIATIONISREQUIRED"), null);

		}

		
		//Burada ki yein amacı kullanıcı daha önce bir kayıt girdiyse ve o kaydın tekrar talep miktarını elle sıfır yaparsa
		//hata verdirtmemk için ekledik.
		var cardItem = this.shoppingCardService.getItems().getValue().find(x => x.id == this._data.productId);
		if (!cardItem) {

			if (this.selectVariationProduct) {
				if (this.orderedQty < 1) {
					return this.uiMessage.modal.warning("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.FORMS.ORDEREDQTYISREQUIRED"), null);

				}
			}
		}
		

		//seçili olan ürünün id si ile aynı olanların eski kayıtlarını siler.
		this.shoppingCardService.removeProductByProductId(this._data.productId);

		var obj = new ProductDto();
		obj.id = this._data.productId;
		obj.variationId = this.selectVariationProduct.variationId;
		obj.orderedQty = this.orderedQty;

		obj.barcode = this.selectVariationProduct.barcode ? this.selectVariationProduct.barcode : null;
		obj.expirationDate = this.selectVariationProduct.expirationDate ? this.selectVariationProduct.expirationDate : null;
		obj.lot = this._data.specialCode ? this._data.specialCode : null;


		obj.name = this.selectVariationProduct.name;
		obj.kod = this.selectVariationProduct.kod;
		obj.wmsTip = this.selectVariationProduct.wmsTip;
		// obj.stok = this.selectVariationProduct.stockQuantity ? this.selectVariationProduct.stockQuantity : 0; 

		//sepet içerisine ekleme işlemini yapıyoruz	
		this.shoppingCardService.addToCart(obj);

		this.dialogRef.close(obj);

	}

	close() {

		this.dialogRef.close();
	}

}
